import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_BY_ID } from 'actions/apiActionConstants'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getMerchandiseById from 'api/merchandise/getMerchandiseById'
import { merchandiseCacheKey } from 'components/Merchandise/merchandiseUtils'

function fetchMerchandiseById(id: string, prioritisedVariantIds?: Array<string>): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const merchandise = state.merchandise.merchandise[id]
    const fetching = state.merchandise.fetchingMerchandise[id]
    const error = state.merchandise.merchandiseErrors[id]

    const cacheKey = merchandiseCacheKey(id, prioritisedVariantIds)
    const validCache = merchandise && merchandise?.cacheKey === cacheKey
    if (validCache || fetching || error) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_BY_ID,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => getMerchandiseById(id, prioritisedVariantIds),
      id,
    })
  }
}

export default fetchMerchandiseById
